import { useState, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { getUserProfile } from '../services/agent';
export const useUserId = () => {
    const { user } = useAuth();
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchUserId = async () => {
            if (!user?.access_token) {
                setUserId(null);
                return;
            }
            // Check if we already have the userId cached in memory
            if (userId) {
                return;
            }
            setLoading(true);
            setError(null);
            try {
                const profile = await getUserProfile(user.access_token);
                console.log('User profile fetched:', profile);
                setUserId(profile.id);
            }
            catch (err) {
                console.error('Failed to fetch user profile:', err);
                setError('Failed to fetch user profile');
            }
            finally {
                setLoading(false);
            }
        };
        fetchUserId();
    }, [user?.access_token, userId]);
    return { userId, loading, error };
};
